module.exports = __webpack_public_path__ + "img/lemon_meringue_pie_filling.e9062f72.jpg";